import React from 'react'
import ReactDOM from 'react-dom'
import { Router, IndexRoute, Route, browserHistory } from 'react-router'
import { MasterPage, IndexPage, LoginPage, RegistrationPage, SearchPage, FavoritesPage, PreferencesPage, NotifsPage, ProfilePage } from './pages'
import authentication from './http/auth'
import { sessionStore } from './reducers'
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'

let checkAuth = (nextState, replace, cb) => {
  const promise = authentication.isAuthenticated()
  promise.then(function(resp) {
    sessionStore.dispatch({'type': 'LOGGED'})
    cb()
  }).catch(function(err) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname },
    })
    cb()
  })
}

ReactDOM.render((
  <Router history={browserHistory}>
    <Route path='/' component={MasterPage}>
      <IndexRoute component={IndexPage} onEnter={checkAuth}/>
      <Route path='/login' component={LoginPage} />
      <Route path='/register' component={RegistrationPage} />
      <Route path='/search' component={SearchPage} onEnter={checkAuth}/>
      <Route path='/favorites' component={FavoritesPage} onEnter={checkAuth}/>
      <Route path='/preferences' component={PreferencesPage} onEnter={checkAuth}/>
      <Route path='/notifs' component={NotifsPage} onEnter={checkAuth}/>
      <Route path='/profile' component={ProfilePage} onEnter={checkAuth}/>
    </Route>
  </Router>
  ), document.getElementById('app-container'))



// WEBPACK FOOTER //
// ./src/index.js